<span class="multi-line-text"
      [class.multi-line-text_marked]="markFirstLine && i === 0"
      *ngFor="let textPart of textParts;let i = index" [innerHTML]="domSanitizer.bypassSecurityTrustHtml(textPart)">
</span>
